module.exports = __webpack_public_path__ + "media/images/logo-dark-new-7a5437c88664309e4645f7cc1150ed50.svg";